import { createAction } from 'redux-act';

// eslint-disable-next-line import/prefer-default-export
export const configLoaded = createAction('Config Loaded');
